import { useInstance } from 'intact-vue-next';
import dayjs from 'dayjs';
import { isEqual } from './helpers';
import { _$ } from '../../i18n';
export function useYears(showDate, status, focusDate) {
  var instance = useInstance();
  function getYearRange() {
    var startYear = Math.floor(showDate.value.get('year') / 10) * 10;
    return [startYear, startYear + 9];
  }
  function getYearLabel() {
    var _getYearRange = getYearRange(),
      start = _getYearRange[0],
      end = _getYearRange[1];
    return _$('{start}年 - {end}年', {
      start: start,
      end: end
    });
  }
  function getYears(now) {
    var years = [];
    var start = showDate.value.toDate();
    var _getYearRange2 = getYearRange(),
      startYear = _getYearRange2[0],
      endYear = _getYearRange2[1];
    start.setFullYear(startYear - 1);
    for (var i = 0; i < 12; i++) {
      var dayjsDate = dayjs(start);
      var year = start.getFullYear();
      var isExceed = year < startYear || year > endYear;
      years.push({
        isExceed: isExceed,
        isActive: !isExceed && status.isActive(dayjsDate, 'year'),
        isToday: dayjsDate.isSame(now, 'year'),
        isDisabled: status.isDisabled(dayjsDate),
        isHover: isEqual(dayjsDate, focusDate.value, 'year'),
        isInRange: !isExceed && status.isInRange(dayjsDate, 'year'),
        label: year,
        value: dayjsDate
      });
      start.setFullYear(year + 1);
    }
    return years;
  }
  function onClick(date) {
    showDate.set(date);
    if (instance.datepicker.get('type') !== 'year') {
      instance.type.set('month');
    } else {
      instance.triggerChange(date);
    }
  }
  return {
    getYearRange: getYearRange,
    getYearLabel: getYearLabel,
    getYears: getYears,
    onClick: onClick
  };
}